import { useEffect, useState } from 'react';

import ModalContainer from '@components/modals/ModalContainer';

import LoaderComponent from '@/components/LoaderComponent';

import { useGetSubCategoryWiseManufacturedDesignsQuery } from '../api/supplierConfigurationApi';
const DevelopedProductViewModal = ({
	onClose,
	manufacturedDesigns,
	isManufacturedDesignsLoading,
	initialActiveTab,
	supplierId
}) => {
	const defaultTabId = manufacturedDesigns?.[0]?.subCategoryId || '';
	const [activeTab, setActiveTab] = useState(
		initialActiveTab && initialActiveTab !== 'all' ? initialActiveTab : defaultTabId
	);
	const {
		data: subCategoryWiseManufacturedDesignsData,
		isLoading: isSubCategoryWiseManufacturedDesignsLoading
	} = useGetSubCategoryWiseManufacturedDesignsQuery(
		{ id: supplierId, subCategoryId: activeTab },
		{ skip: !supplierId || !activeTab }
	);

	useEffect(() => {
		const nextTab = initialActiveTab && initialActiveTab !== 'all' ? initialActiveTab : defaultTabId;

		setActiveTab(nextTab);
	}, [defaultTabId, initialActiveTab]);

	const activeTabWiseDesgin = subCategoryWiseManufacturedDesignsData?.payload || [];

	return (
		<LoaderComponent
			loading={
				isManufacturedDesignsLoading || (!!activeTab && isSubCategoryWiseManufacturedDesignsLoading)
			}
		>
			<div>
				<ModalContainer onCloseModal={onClose} className="product-view-modal">
					<div className="common-popup product-view-modal">
						<div className="common-popup-header d-flex justify-content-between">
							<div className="popup-tilte">
								<h3 className="semibold-16 mb-0">Developed Products</h3>
							</div>
							<div className="close-btn" onClick={onClose}>
								<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
							</div>
						</div>
						<div className="common-popup-body">
							<div className="inner-tabs mb-4">
								<ul className="d-flex align-items-center">
									{manufacturedDesigns?.map((subcategory) => (
										<li
											key={subcategory?.subCategoryId}
											className={
												activeTab === subcategory?.subCategoryId ? 'active' : ''
											}
											onClick={() => setActiveTab(subcategory?.subCategoryId)}
										>
											{subcategory?.subCategoryName}
										</li>
									))}
								</ul>
							</div>
							<div className="all-products d-grid grid-columns-4 gap-3 supplier-products scroll-y-label">
								{activeTabWiseDesgin?.length > 0 ? (
									activeTabWiseDesgin.map((doc) => (
										<div
											key={doc?.id || doc?.docUrl}
											className="single-design-card with-editable shadow-1dp"
										>
											<div className="card-top">
												<img alt="Design" src={doc?.docUrl} />
											</div>
										</div>
									))
								) : (
									<p>No designs available</p>
								)}
							</div>
						</div>
					</div>
				</ModalContainer>
			</div>
		</LoaderComponent>
	);
};

export default DevelopedProductViewModal;
